// S8 (ATAI-101) is Dev Completed — Investor Status / Touchpoint are real,
// numeric-id-backed enums served by investor-service (`GET
// /ps-core/contacts/investor-statuses` / `/touchpoints`, see
// data/contacts/psCoreService.js). Profile/index.js fetches those live and
// maps {id, name} -> {value, label}, replacing this list once the fetch
// resolves; nothing here is sent to the API directly.
//
// This list is also the default source: per product decision, the first
// entry ("New" / "Not Touched") is what the dropdown shows for a contact
// with no saved value yet, rather than a blank "Select" placeholder — see
// Profile/index.js's own use of `InvestorStatusOptions[0]`/
// `TouchpointOptions[0]`. So this doubles as the fetch-failure fallback
// AND the pre-fetch/no-value default, not just a failure-only fallback.
//
// The ids below are NOT placeholders — they're the real ids these two DDL-
// seeded lookup tables use (confirmed live against dev's investor-service,
// `GET /ps-core/contacts/investor-statuses` / `/touchpoints`), matching
// `seq` order. Seeded by migration, not created at runtime, so they're fixed
// across environments. Using the real ids here matters: the `?contactId=`
// response's numeric `id` (the row with `selected: true`) must equal one of
// these `value`s for the Dropdown to show the saved selection when it's used
// as a fallback options list — a string/number mismatch left the control
// rendering blank despite a real saved value.
export const InvestorStatusOptions = [
  { value: 1, label: 'New' },
  { value: 2, label: 'Contact Info Found' },
  { value: 3, label: 'Contacted' },
  { value: 4, label: 'Qualified Buyer' },
  { value: 5, label: 'Active Buyer' },
  { value: 6, label: 'Do Not Contact' },
  { value: 7, label: 'Inactive' },
];

export const TouchpointOptions = [
  { value: 1, label: 'Not Touched' },
  { value: 2, label: 'Called' },
  { value: 3, label: 'Left Voicemail' },
  { value: 4, label: 'Texted' },
  { value: 5, label: 'Emailed' },
  { value: 6, label: 'Spoke With Investor' },
  { value: 7, label: 'Follow Up Scheduled' },
  { value: 8, label: 'Sent Deal' },
  { value: 9, label: 'Closed Deal' },
];

// Last-resort fallback if even the options arrays above were ever empty
// (shouldn't happen — they're hardcoded, not fetched). Everyday "no value
// yet" is InvestorStatusOptions[0]/TouchpointOptions[0], not this; see
// their comment above. `null` is still what the backend itself uses to mean
// "cleared" (ContactWorkflowRequest.java), so this stays `null` rather than
// a numeric id that might not exist.
export const DefaultInvestorStatus = null;
export const DefaultTouchpoint = null;
